module.exports = "/_next/static/resources/man-2-0cf1d7e6b4c679f4535ed173844f394b.webp";